import { useState } from "react";

interface AvaliacaoResposta {
    avaliacao: number | null;
    avaliarResposta: (idResposta: number, avaliacao: number) => void;
}

export const AvaliarMensagem = (): AvaliacaoResposta => {
    const [avaliacao, setAvaliacao] = useState<number | null>(null);

    const avaliarResposta = async (idResposta: number, avaliacao: number) => {
        setAvaliacao(avaliacao);

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            id_resposta: idResposta,
            avaliacao: avaliacao,
        });

        const requestOptions: RequestInit = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        try {
            const response = await fetch(
                "https://app.sak.com.br/Bot/avaliarResposta",
                requestOptions
            );
            await response.text();
        } catch (error) {
            console.error("Erro ao avaliar resposta:", error);
            setAvaliacao(null);
        }
    };

    return { avaliacao, avaliarResposta };
};
